import { memo, useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useStore } from 'store/StoreContext';
import { callSendOnetimePasswordMailApi } from 'requests/RequestUser';
import { RoutePath } from 'consts/RoutePath';
import { UpdateUserReqData } from 'requests/RequestUser';
import { CircularProgress } from '@material-ui/core';
import { HttpStatus } from 'consts/HttpStatus';
import { convertObjectToGetParameterWithEncode } from 'common/ObjectToGetParameterConverter';

type Props = {};

export const ProfileEditMailAddressTemplate = memo((_props: Props) => {
	const [store] = useStore();
	const history = useHistory<UpdateUserReqData>();
	const location = useLocation();
	const search = location.search;
	const queryParams = new URLSearchParams(search);
	const isRequiredProfile = queryParams.get('isRequiredProfile')
		? 'true' === queryParams.get('isRequiredProfile')
		: false;
	const [processLoading, setProcessLoading] = useState(false);
	const back = () => {
		if (isRequiredProfile) {
			const getParameters = convertObjectToGetParameterWithEncode(
				store.authorizeV2Data,
				'code_challenge',
				'redirect_uri',
				'nonce',
			);
			history.push(`${RoutePath.REQUIRED_PROFILE_EDIT}?${getParameters}`, history.location.state);
		} else {
			history.push(RoutePath.PROFILE_EDIT, history.location.state);
		}
	};

	const sendMail = async () => {
		setProcessLoading(true);

		// メール送信API
		const sendMailResult = await callSendOnetimePasswordMailApi({
			mailaddress: history.location.state.data.mailaddress_1,
			send_type: 2,
		});
		if (sendMailResult.status !== HttpStatus.OK) {
			history.push(RoutePath.ERROR);
			return;
		}

		// 次のページへ
		if (isRequiredProfile) {
			const getParameters = convertObjectToGetParameterWithEncode({ isRequiredProfile: 'true' });
			history.push(`${RoutePath.PROFILE_EDIT_MAILADDRESS_CONFIRM}?${getParameters}`, history.location.state);
		} else {
			history.push(RoutePath.PROFILE_EDIT_MAILADDRESS_CONFIRM, history.location.state);
		}
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenIDプロフィール変更｜メールアドレスの確認';
	}, []);

	return (
		<>
			<section className="section">
				<div className="section-in" ref={scrollRef}>
					<div className="section-head">プロフィール変更</div>
					<div className="section-txt-box">
						<div className="txt-head">メールアドレスの確認</div>
						<p>
							プロフィールに登録されているメールアドレスが変更されます。
							<br />
							記載のメールアドレスに誤りがないことを、ご確認ください。
						</p>
					</div>

					<div className="form-box">
						<div className="form-head">
							<label htmlFor="">{`変更後のメールアドレス：${history.location.state.data.mailaddress_1}`}</label>
						</div>
					</div>
					<div className="btn-box">
						{processLoading ? (
							<CircularProgress />
						) : (
							<>
								<div className="btn wh">
									<button onClick={back}>変更画面に戻る</button>
								</div>
								<div className="btn gr">
									<button onClick={sendMail}>確認</button>
								</div>
							</>
						)}
					</div>
				</div>
			</section>
		</>
	);
});
